export function BubbleTrail({
  size = 10,
  step,
  steps,
  base = 0,
}: {
  size?: number;
  step: number;
  steps: number;
  base?: 0 | 1;
}) {
  const inc = base === 0 ? 1 : 0;
  return (
    <div className="inline-flex gap-2">
      {new Array(steps + inc).fill(1).map((_, i) => (
        <div
          key={i}
          className={`${i === step ? 'bg-primary' : 'bg-primary/30'}`}
          style={{
            borderRadius: size,
            width: i === step ? size * 2 : size,
            height: size,
            transition: 'all 0.3s',
          }}
        />
      ))}
    </div>
  );
}
